import { render, staticRenderFns } from "./DeMinimis.vue?vue&type=template&id=63023a95&"
import script from "./DeMinimis.vue?vue&type=script&lang=js&"
export * from "./DeMinimis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports